import React, { useState } from "react"
import styled from "styled-components"

export function useZIndexes(children: React.ReactNode[]) {
  const [zIndexes, setZIndexes] = useState(
    children.map(() => Math.round(Math.random() * children.length)),
  )
  const setTopIndex = (topIx: number) => {
    setZIndexes((ixs) => [...ixs.filter((i) => i !== topIx), topIx])
  }
  return [zIndexes, setTopIndex]
}

export const ZWrapper = styled.div<{ zIndex: number }>`
  z-index: ${(p) => p.zIndex};
  position: absolute;
`
